import { humanizeName } from "../utils/rateConcepts";
import { humanizeCondition } from "../utils/humanizeCondition";
import { formatCOP } from "../utils/money";
import { PencilSquare } from "react-bootstrap-icons";
import { Button } from "react-bootstrap";

export default function ItemRow({
  item,
  concepts,
  catalogConditions,
  places,
  onEdit,
}) {
  const concept = concepts.find((c) => c.id === item.concept_id);
  
  const conditionId = item.condition_group_id == null ? null : Number(item.condition_group_id);

  const condition = catalogConditions.find(
    (c) => Number(c.id) === conditionId
  );

  return (
    <tr>
      <td>{humanizeName(concept?.name)}</td>
      <td style={{textAlign: 'right'}}>{formatCOP(item.value_cents/100)}</td>
      <td>
        {condition ? (
          <>
            {humanizeCondition(condition, { places })}
          </>
        ) : ('Sin condición')}
        </td>
      <td>
        <Button
          variant="outline-info"
          size="sm"
          onClick={onEdit}
        >
          <PencilSquare />
        </Button>
      </td>
    </tr>
  );
}
